import { useTranslation } from 'react-i18next';
import { KoobTooltip } from '@koob/ui';

export default function ActiveJobTooltip({ position, children }) {
  const { t } = useTranslation('toConnectionRequest');

  return (
    <KoobTooltip tip={t('updatingRequestTooltip')} position={position}>
      {children}
    </KoobTooltip>
  );
}
